export default __webpack_public_path__ + "static/media/feather-upload-cloud.4866cd03.svg";